import React, {useState, useRef, useImperativeHandle, forwardRef} from "react";

import css from "./index.module.scss";


export default forwardRef(({
  onChange = () => {},
  label = "Test",
  name = "test",
  value = "",
  className = "",
  defaultChecked = false,
}, ref) => {
  const radioRef = useRef();

  useImperativeHandle(ref, () => ({
    isValid() {
      return true;
    },
    getValue() {
      if (radioRef?.current?.checked){
        return value;
      }
      return null;
    },

  }));

  function handleChange(){
    if (radioRef?.current?.checked){
      onChange(value);
    }
  }
  return (<div className={`${css.radioButton} ${className}`}>
    <label>
      <input type="radio" name={name} defaultChecked={defaultChecked} onChange={handleChange} ref={radioRef}/>
      <div className={css.circle}></div>

      <div className={css.label}>{label}</div>
    </label>
  </div>
  );
});
